var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _host, _psk, _fetcher, _psk2;
import { T as TOTP, S as Secret } from "./otpauth.esm-675c01d0.mjs";
class Fetcher {
  /**
   * Create a new Fetcher instance
   * @param host The base URL of the API
   * @param psk The pre-shared key for the TOTP to authenticate with the API
   */
  constructor(host, psk) {
    __privateAdd(this, _host, void 0);
    __privateAdd(this, _psk, void 0);
    __privateSet(this, _host, host);
    __privateSet(this, _psk, psk);
  }
  async request(method, url, data, headers) {
    const totp = new TOTP({
      secret: Secret.fromBase32(__privateGet(this, _psk)),
      algorithm: "SHA1",
      digits: 12,
      period: 60
    });
    const token = totp.generate();
    const requestOptions = {
      method,
      headers: {
        "x-csrf-token": token,
        "Content-Type": "application/json",
        Accept: "application/json",
        ...headers
      }
    };
    if (data) {
      requestOptions.body = JSON.stringify(data);
    }
    const uri = new URL(url, __privateGet(this, _host));
    const response = await fetch(uri.toString(), requestOptions);
    const responseData = await response.json().catch(() => ({}));
    return {
      data: responseData,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: requestOptions,
      request: {}
      // This is a placeholder, Fetch doesn't provide a request object like Axios
    };
  }
  get baseUrl() {
    return __privateGet(this, _host);
  }
  get(url, headers) {
    return this.request("GET", url, null, headers);
  }
  delete(url, headers) {
    return this.request("DELETE", url, null, headers);
  }
  head(url, headers) {
    return this.request("HEAD", url, null, headers);
  }
  options(url, headers) {
    return this.request("OPTIONS", url, null, headers);
  }
  post(url, data, headers) {
    return this.request("POST", url, data, headers);
  }
  put(url, data, headers) {
    return this.request("PUT", url, data, headers);
  }
  patch(url, data, headers) {
    return this.request("PATCH", url, data, headers);
  }
}
_host = new WeakMap();
_psk = new WeakMap();
const _Sudo = class _Sudo {
  /**
   * Create an instance of the Sudo class
   * @param host The hostname of the Malarkey API Server to connect with
   * @param psk The pre-shared key for validating Malarkey API requests
   */
  constructor(host, psk) {
    __privateAdd(this, _fetcher, void 0);
    __privateAdd(this, _psk2, void 0);
    __privateSet(this, _fetcher, new Fetcher(host, psk));
  }
  /**
   * Identify as a sudoer
   * @param psk The pre-shared key for sudoers
   */
  su(psk) {
    __privateSet(this, _psk2, psk);
  }
  /**
   * Get credentials to impersonate authentication as the specified user
   * @param type The type of user to impersonate
   * @param id The ID of the user to impersonate
   * @returns the Axios-Like Response of the request to get credentials to authenticate as the user
   */
  async getImpersonatedIdentity(type, id) {
    if ("string" !== typeof __privateGet(this, _psk2)) {
      throw new Error("You must first identify yourself as a sudoer");
    }
    const totp = new TOTP({
      secret: Secret.fromBase32(__privateGet(this, _psk2)),
      algorithm: "SHA1",
      digits: 12,
      period: 60
    });
    const otp = totp.generate();
    return await __privateGet(this, _fetcher).post("/identity/from-sudo", {
      otp,
      type,
      id
    });
  }
  static su(host, psk, sudoPsk) {
    const instance = new _Sudo(host, psk);
    instance.su(sudoPsk);
    return instance;
  }
};
_fetcher = new WeakMap();
_psk2 = new WeakMap();
let Sudo = _Sudo;
if ("undefined" !== typeof window) {
  window.Sudo = Sudo;
}
const sudo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Sudo
}, Symbol.toStringTag, { value: "Module" }));
export {
  Sudo as S,
  sudo as s
};
//# sourceMappingURL=sudo-bad5b55e.mjs.map
